module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/biaoqian_icon_more.2ca82.png";